export const TagColorType = Object.freeze({
  orange: 0,
  blue: 1,
  purple: 2,
  red: 3,
});

export const TagColorLabel = Object.freeze({
  [TagColorType.orange]: 'orange',
  [TagColorType.blue]: 'blue',
  [TagColorType.purple]: 'purple',
  [TagColorType.red]: 'red',
});
